import { render } from "./UserRecoveryChart.vue?vue&type=template&id=065fdc2a&scoped=true"
import script from "./UserRecoveryChart.vue?vue&type=script&lang=js"
export * from "./UserRecoveryChart.vue?vue&type=script&lang=js"

import "./UserRecoveryChart.vue?vue&type=style&index=0&id=065fdc2a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065fdc2a"]])

export default __exports__